import React, { useContext } from 'react'
import { Modal, Stack } from '@mui/material'
import { AddressForm, AddressSaved } from '../views/address'
import { AppContext } from '../../context'
import { ProductQuantity } from '../views/product'
import { PreviewOrder } from '../views/preview-order'
import { PickDate } from '../views/pick-date/PickDate'
import { HistoryOrders } from '../views/history'
import { OrderInvoice } from '../views/invoice'
import { OrderDone } from '../views/order-done'
import { Account } from '../views/account/Account'
import { useEffect } from 'react'

export const CustomModal = () => {
  const { isOpen, handleIsOpen } = useContext(AppContext)
  

  return (
    <Modal
      open={ isOpen }
      onClose={ handleIsOpen }
      disableAutoFocus
      
    >
      <></>
      {/* <AddressSaved/> */}
      {/* <ProductQuantity /> */}
      {/* <PickDate /> */}
      {/* <PreviewOrder /> */}
      {/* <ScheduleOrder /> */}
      {/* <HistoryOrders /> */}
      {/* <OrderInvoice /> */}
      {/* <OrderDone /> */}
      {/* <Account /> */}
    </Modal>
  )
}
